import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('soa-status-lookup')
@Component({
    selector: 'app-soa-status-lookup',
    templateUrl: './soa-status-lookup.component.html',
    styleUrls: ['./soa-status-lookup.component.scss'],
    standalone: false
})
export class SoaStatusLookupComponent extends FormEntryComponentClass implements OnInit {

  selectedFilter = "";
  selectedSort = "";

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
